<template>
  <v-container 
    id="ty-page"
    fill-height 
    dark
  >
    <v-row class="text-center pb-0" justify="center">
      <v-col cols="11" md="9" lg="7" class="px-6">
          <v-icon right color="green accent-3" x-large class="mb-6">mdi-progress-check</v-icon>
        <h2 class="c-primary--text mb-4 font-weight-bold">
          Em processamento...
        </h2>
        <p class="mt-2 body-2">Seu pagamento está em processamento. Assim que ele for autorizado basta <strong>enviar o seu comprovante de pagamento para nosso endereço de e-mail: <a href="mailto:cursos.centrofluminense@gmail.com" target="_blank">cursos.centrofluminense@gmail.com</a></strong></p>
      </v-col>
      <v-col cols="11" md="7">
        <v-alert
          type="info"
          dense
          outlined
          class="text-left mt-3 body-2"
        >
          Lembre-se de enviar o comprovante do pagamento para o email <strong>cursos.centrofluminense@gmail.com</strong>
        </v-alert>
      </v-col>
      <v-col cols="11" lg="6" class="px-6">
        <!-- <p class="caption mt-4">Clique no botão abaixo para ir ao pagamento:</p> -->
        <v-btn
          color="btn-primary darken-1"
          large
          dark
          depressed
          @click.stop="$router.push('/pre-inscricao')"
        >
          <v-icon left>mdi-arrow-left</v-icon>
          Página do curso
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Processando',
  // beforeMount() {
  //   this.$vuetify.theme.dark = true
  // },
}
</script>

<style lang="scss">
@import '@/variables/style.scss';
#ty-page {
  h3 {
    // font-size: ;
    font-weight: 500;
  }
  h2 {
    font-size: 2rem;
    font-weight: 500;
  }
}
</style>